import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { index, destroy } from '../../../store/actions/links.action'
import { AppBar, Button, CardHeader, CircularProgress, Divider, IconButton, Menu, MenuItem, Slide, Typography, Toolbar, Drawer } from '@material-ui/core'
import { FaTrash, FaPencilAlt, FaSlidersH, FaPlus, FaChartBar, FaLink } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FcFilingCabinet, FcBarChart } from 'react-icons/fc'
import { MdMoreHoriz } from 'react-icons/md'
import { Confirm } from '../../components'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import { SCROLL, domain } from '../../../config/App'
import { changeNotify } from '../../../store/actions/notify.action'
import CustomFilterButtons from '../../components/chart/custom-filter-buttons'


export default function Links(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.uid) ? props.uid : null;
    const { theme } = useSelector(state => state.appReducer)
    const { links, success } = useSelector(state => state.linksReducer)

    const [isLoading, setLoading] = React.useState(true)
    const [ isLoadMore, setLoadMore ] = React.useState(false)
    const [filter, setFilter] = React.useState(false)
    const [source, setSource] = React.useState('all')
    const [query, setQuery] = React.useState({ 
        page: 1 , 
        campaign_id: campaign_id,
        source: source
    })

    const [state, setState] = React.useState({
        menuEl: null,
        isDeleted: null,
        confirmEl: null
    })

    React.useEffect(() => {
		var clipboard = new window.ClipboardJS('.btn');

		clipboard.on('success', function(e) {
			dispatch(changeNotify({
                open: true,
                msg: 'Link copiado com sucesso',
                class: 'success'
            }))
		});
	},[])

    React.useEffect(() => {
        if(success) {
            setLoading(true)
            dispatch(index({ page: 1 , campaign_id: campaign_id}, isLoadMore)).then(res => {
                setLoading(false)
                setLoadMore(false)
            })
        }
    },[success])

    React.useEffect(() => {
        document.addEventListener('scroll', _handleScroll)
        return () => document.removeEventListener('scroll', _handleScroll)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        setQuery(prev => {
            if (prev.source === source) return prev;

            setLoading(true);

            return {
                ...prev,
                page: 1,
                source
            };
        });

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source]);

    React.useEffect(() => {
        _index(isLoadMore)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    React.useEffect(() => {
        if(isLoadMore) {
            setQuery({
                ...query,
                page: query.page + 1
            })
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadMore])

    const _handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.srcElement.documentElement
        let scroll = scrollHeight - (clientHeight + scrollTop)
        if(scroll < SCROLL) {
            if(!isLoadMore && _handleLoadMore());
        }
    }

    const _handleLoadMore = () => {
        if(links.current_page < links.last_page) { 
            setLoadMore(true)
        }
    }

    const _index = (loadMore, loading = false) => {
        dispatch(index(query, loadMore, loading)).then(res => {
            setLoading(false)
            setLoadMore(false)
        })
    }

    const _destroy = (id) => {
        setState({ isDeleted: id })
        dispatch(destroy(id)).then(res => res && setState({ isDeleted: null }))
    }

    const handlePage = (page, id = null, link_id) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                uid: id,
                campaign_id: campaign_id,
                link_id: link_id
            }
        }))
    }

    const Transition = React.forwardRef((props, ref) => {
        return <Slide direction="up" ref={ref} {...props} />
    })

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Links</Typography>
                    
                    <Button
                        variant="contained" 
                        size="small"
                        onClick={() => handlePage('links-create')} 
                        color="inherit"
                        className="ms-auto btn-app-bar"
                        startIcon={<FaPlus />}
                    >
                        Cadastrar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">


            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                <>
                    <Drawer 
                        anchor="bottom"
                        open={filter}
                        onClose={() => setFilter(false)}
                    >
                        <div className="card p-3 mb-2 bs-bg">
                            <h6 className="bs-color-b mb-3">Filtros</h6>

                            <CustomFilterButtons
                                source={source}
                                onFilter={({ source }) => {
                                    setSource(source)
                                    setFilter(false)
                                }}
                            />
                        </div>
                    </Drawer>

                    <div className="card-body d-flex justify-content-between">
                        {(links.data.length > 0) ?
                            <label className="label-custom m-0 bs-color">{links.total.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                            :
                            <span></span>
                        }
                        
                        <div className="d-flex gap-2">
                            <Button
                                className={"bs-bg-invert bs-color-b icon-button"}
                                variant="contained" 
                                color="primary"
                                onClick={() => handlePage('chart-links', campaign_id)}
                                startIcon={<FaChartBar />}
                            >
                            </Button>

                            <Button
                                className={"bs-bg-invert bs-color-b icon-button"}
                                variant="contained" 
                                color="primary"
                                onClick={() => setFilter(true)}
                                startIcon={<FaSlidersH />}
                            >
                            </Button>
                        </div>
                    </div>

                    {(links.data.length < 1) &&
                        <div className="card card-body bs-bg">
                            <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                <FcFilingCabinet size="70" />
                                <h6 className="mt-4 text-muted bs-color">Nenhum registro cadastrado</h6>
                            </div>
                        </div>
                    }

                    {(links.data.length > 0) &&
                    <>
                        {links.data.map((item, index) => (
                            <div className="card card-body mb-3 bs-bg" key={index}>
                                <div>
                                    {(item.afiliado) &&
                                        <small className="badge bg-secondary">AFILIADO</small>
                                    }
                                    {(item.gestor) &&
                                        <small className="badge bg-success">GESTOR</small>
                                    }
                                    {(!item.afiliado && !item.gestor) &&
                                        <small className="badge bg-theme">ADMIN</small>
                                    }
                                </div>
                                <CardHeader 
                                    title={<h5 className="fw-bold bs-color-b">{item.title}</h5>}
                                    subheader={<small className="fw-bold bs-color">Cadastrado: {new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(item.created_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.created_at))}</small>}
                                    action={
                                        <>
                                        <IconButton className="p-0 bs-color" id={index} onClick={event => setState({ menuEl: event.currentTarget })}>
                                            <MdMoreHoriz size="1.2em" />
                                        </IconButton>

                                        {(Boolean(state.menuEl)) &&
                                            <Menu
                                                anchorEl={state.menuEl}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                TransitionComponent={Transition}
                                                open={(index === parseInt(state.menuEl.id))}
                                                onClose={() => setState({ menuEl: null })}
                                            >
                                                <MenuItem 
                                                    onClick={() => {
                                                        setState({ menuEl: null })
                                                        handlePage('transactions', campaign_id, item.id)
                                                    }}
                                                    className="bs-color-b"
                                                >
                                                    <FcBarChart size="1.2em" className="me-4 fw-bold" /> <strong>TRANSAÇÕES</strong>
                                                </MenuItem>

                                                <Divider />
                                            
                                                <MenuItem 
                                                    onClick={() => {
                                                        setState({ menuEl: null })
                                                        handlePage('links-edit', item.id)
                                                    }}
                                                    className="bs-color-b"
                                                >
                                                    <FaPencilAlt size="1.2em" className="me-4" /> <strong>Editar</strong>
                                                </MenuItem>

                                                <Divider />

                                                <MenuItem 
                                                    onClick={() => setState({ confirmEl: item.id })}
                                                    className="bs-color-b"
                                                >
                                                    <FaTrash color="#dc3545" size="1.2em" className="me-4" /> <strong>Apagar</strong>
                                                </MenuItem>
                                                
                                                <div className='mt-3'></div>
                                            </Menu>
                                        }
                                        {(state.confirmEl === item.id) && 
                                            <Confirm
                                                secure
                                                open={(item.id === state.confirmEl)}
                                                onConfirm={() => _destroy(item.id)}
                                                onClose={() => setState({ confirmEl: null })}
                                                title="Para confirmar a exclusão, insira excluir no campo abaixo"
                                            />
                                        }
                                        </>
                                    }
                                />

                                <input type="text" style={{opacity: '0', position: 'fixed', left: '-9999px'}} value={'https://'+domain+'/campaign/'+item.url_amigavel+'?link_ref='+item.id} id={"copy_link_"+item.id} readOnly/>

                                <CardHeader
                                    className="pb-0"
                                    title={
                                        <>
                                        <div className="d-flex gap-3">
                                            <Button
                                                size="small"
                                                className={"bs-bg-invert bs-color-b fw-bold "  + (theme === 'dark' && 'btn-checked')}
                                                variant="contained" 
                                                color="primary"
                                                startIcon={<FaChartBar />}
                                                onClick={() => handlePage('chart-link', item.id)}
                                            >
                                                Análise
                                            </Button>
            
                                            <Button
                                                size="small"
                                                className={"bs-bg-invert bs-color-b fw-bold copy " + (theme === 'dark' && 'btn-checked')}
                                                variant="contained" 
                                                color="primary"
                                                startIcon={<FaLink />}
                                                data-clipboard-target={"#copy_link_"+item.id}
                                            >
                                                Copiar
                                            </Button>
                                        </div>
                                        </>
                                    }
                                /> 
                            </div>
                        ))}

                        {(isLoadMore) && <div className="text-center card-body"><CircularProgress /></div>}
                    </>
                    }
                </>
            }
            </div>
        </>
    )
}